import { request } from './request';

export const getChatMenus = async (params = {}, options = {}) => {
    const data = await request.get('/v1/sessions', params, options);

    return data;
};

export const getChatList = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.get(`/v1/sessions/${id}/history`, {}, options);

    return data;
};

export const getChatMenu = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.get(`/v1/sessions/${id}`, {}, options);

    return data;
};

// 修改菜单标题
export const editChatMenu = async (params = {}, options = {}) => {
    const { id, title } = params;
    const data = await request.put(
        `/v1/sessions/${id}`,
        {
            title,
        },
        options,
    );

    return data;
};

// 删除菜单
export const deleteChatMenu = async (params = {}, options = {}) => {
    const { id, title } = params;
    const data = await request.delete(`/v1/sessions/${id}`, {}, options);

    return data;
};

export const getInspirations = async (params = {}, options = {}) => {
    const data = await request.get(`/v1/inspirations`, params, options);

    return data;
};
